import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular/lazy';
import { EventService } from 'src/app/services/event.service';
import { ObserverService } from 'src/app/services/observer.service';
import moment from 'moment-timezone';
import { SelectEventSessionTicketTypePage } from 'src/app/modals/select-event-session-ticket-type/select-event-session-ticket-type.page';

@Component({
    selector: 'app-select-event-session',
    templateUrl: './select-event-session.page.html',
    styleUrls: ['./select-event-session.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SelectEventSessionPage implements OnInit {

    moment = moment;
    @Input() event_id = null;
    event = null;
    sessions = null;

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        private eventService: EventService,
        private observerService: ObserverService
    ) { }

    ngOnInit() {
        
        this.eventService.getEvent(this.event_id).then((event) => {
            this.event = event;
        });

        this.eventService.getEventSessions(this.event_id).then((sessions: any) => {
            if (this.event.allow_session_dates) {
                sessions.sort((a, b) => {
                    if (a.start_date < b.start_date) { return -1; }
                    if (a.start_date > b.start_date) { return 1; }
                    return 0;
                });
            }
            else {
                sessions.sort((a, b) => {
                    if (a.order < b.order) { return -1; }
                    if (a.order > b.order) { return 1; }
                    return 0;
                });

            }
            this.sessions = sessions;
        });

        this.observerService.subscribe('event_session_added|select_event_session_modal', (session) => {
            if (session) {
                this.sessions.push(session);
                // NOTE: we don't re-sort at this point, as it would clause jank
            }
        });

        this.observerService.subscribe('event_session_deleted|select_event_session_modal', (session) => {
            if (session) {
                for (let i = 0; i < this.sessions.length; i++) {
                    if (this.sessions[i].id === session["id"]) {
                        this.sessions.splice(i, 1);
                        break;
                    }
                }
            }
        });

        this.observerService.subscribe('event_session_updated|select_event_session_modal', (session) => {
            if (session) {
                for (let i = 0; i < this.sessions.length; i++) {
                    if (this.sessions[i].id === session["id"]) {
                        this.sessions[i] = session;
                        break;
                    }
                }
            }
        });

    }

    ngOnDestroy() {
        this.observerService.destroy("event_session_added|select_event_session_modal");
        this.observerService.destroy("event_session_deleted|select_event_session_modal");
        this.observerService.destroy("event_session_updated|select_event_session_modal");
    }

    close() {
        this.modalController.dismiss();
    }

    async presentSelectSessionTicketTypeModal(event, session) {
        const modal = await this.modalController.create({
            component: SelectEventSessionTicketTypePage,
            componentProps: {
                event_id: event.id,
                session_id: session.id
            }
        });
        return await modal.present();
    }

}
